import { TextboxController } from "./textbox-controller.interface";
import { TextboxComponent } from "../textbox.component";

export class NumberController implements TextboxController {
    component: TextboxComponent;
    public _options: NumberOptions;
    _precisionHasBeenSet: boolean = false;

    set options(val: NumberOptions) {
        this._options = Object.assign(this.defaultOptions(), val);
    }

    get options() { return this._options; }

    get ctrl() {
        if (this.component.formGroup)
            return this.component.formGroup.get(this.component.componentData.key);
        else
            return null;
    }

    constructor() {
        this._options = this.defaultOptions();
    }

    setup(args: any) {
        if (!args)
            return;

        this.options = Object.assign(this.defaultOptions(), args);
    }

    afterViewInit() {

        let val = this.component.getContextValue();

        if (val != null && val != undefined && this.isValidValue(val)) {
            this.setValue(val);
            this.blur();
        }
        else if (this.options.setDefaultOnEmpty) {
            this.setValue(this.options.defaultValue);
            this.blur();
        }
    }

    onInit() {
    }

    onDestroy() {
        this.setValue(this.component.getContextValue());
        this.blur();
    }

    public _setPrecision() {
        if (!this._precisionHasBeenSet) {
            if (this._options.precision > -1)
                this.component.mask = `separator.${this._options.precision}`;
            else
                this.component.mask = 'separator';
        }
    }

    setValue(val: number | string) {
        if (typeof val === 'string') {
            val = val.replace(/[^0-9.-]/gi, '');
            val = parseFloat(val);
            if (isNaN(val)) {
                val = 0;
            }
            
        }
        if (val == null) {
            val = 0;
        }

        this.component.setContextValue(val);
    }

    isValidValue(val: string | number) {
        if (typeof val === 'string') {
            val = val.replace(/,/gi, '');
            val = parseFloat(val);
        }
            

        return !isNaN(val);
    }

    blur() {
        if (!this.ctrl || !this.component.inputView)
            return;

        let contextValue = this.component.getContextValue();;
        let num: any = contextValue;
        if (typeof num === 'string') {
            num = num.replace(/[^0-9.-]/gi, '');
            num = parseFloat(num);
        }

        if (isNaN(num) && contextValue != "") {
            if (this._options.enforcePrecision)
                num = 0;
            else
                return;
        }

        let displayStr = null;
        if (num === null || num === undefined || contextValue === "")
            displayStr = '';
        else {
            if (!this._options.enforcePrecision)
                displayStr = num.toString(10);
            else
                displayStr = num.toFixed(this._options.precision);
        }

        if (displayStr) {
            this._setPrecision();
            this.ctrl.setValue(displayStr);
            this.component.saveContextData(`${this.component.componentData.contextTarget}.displayValue`, this.component.inputView.nativeElement.value);
        }
    }

    protected defaultOptions(): NumberOptions {
        return {
            enforcePrecision: false,
            precision: -1,
            setDefaultOnEmpty: false,
            defaultValue: null
        };
    }

    focus() {
        this._setPrecision();
    }
}

export interface NumberOptions {
    precision?: number;
    enforcePrecision?: boolean;
    setDefaultOnEmpty?: boolean;
    defaultValue?: number;
}